<app-list-module-table variant="surface" [columns]="columns" [rows]="rows" [loading]="loading"
  [emptyMessage]="emptyMessage" rowTrackKey="id">
  <ng-template listCellDef="template_name" let-row="row">
    <span class="text-black dark:text-white">{{ row.template_name || '—' }}</span>
  </ng-template>

  <ng-template listCellDef="subject" let-row="row">
    <span class="text-sm text-gray-700 dark:text-white-dark" [title]="row.subject || ''">
      {{ row.subject || '—' }}
    </span>
  </ng-template>

  <ng-template listCellDef="status" let-row="row">
    @if (P.EMAIL_TEMPLATE_TOGGLE | hasPermission) {
    <button
      type="button"
      class="email-toggle"
      [class.is-active]="row.is_active"
      [attr.aria-pressed]="!!row.is_active"
      [attr.aria-label]="row.is_active ? 'Deactivate template' : 'Activate template'"
      (click)="toggleStatus.emit(row)"
    >
      <span class="email-toggle__label">{{ row.is_active ? 'On' : 'Off' }}</span>
      <span class="email-toggle__knob" aria-hidden="true"></span>
    </button>
    } @else {
    <span [class]="statusClass(row.is_active)">{{ statusLabel(row.is_active) }}</span>
    }
  </ng-template>

  <ng-template listCellDef="actions" let-row="row">
    <div class="inline-flex items-center gap-1">
      @if (P.EMAIL_TEMPLATE_UPDATE | hasPermission) {
      <a [routerLink]="editLink(row.id)"
        class="inline-flex h-9 w-9 items-center justify-center rounded-lg text-primary hover:bg-primary/10"
        title="Edit template">
        <icon-edit class="h-4 w-4" />
      </a>
      }
      @if (P.EMAIL_TEMPLATE_LIST | hasPermission) {
      <button type="button"
        class="inline-flex h-9 w-9 items-center justify-center rounded-lg text-blue-500 hover:bg-blue-500/10"
        title="Preview template" (click)="preview.emit(row)">
        <icon-eye class="h-4 w-4" />
      </button>
      }
    </div>
  </ng-template>
</app-list-module-table>